import type { DashboardComponentType } from "shared/dashboards/domain/dashboardComponentType";

export interface Dashboard {
  id: string;
  name: string;
  components: DashboardComponent[];
}

export interface DashboardComponent {
  id: string;
  type: DashboardComponentType;
  x: number;
  y: number;
  width: number;
  height: number;
}

export function componentEqual(a: DashboardComponent, b: DashboardComponent) {
  return a.id === b.id &&
    a.type === b.type &&
    a.x === b.x &&
    a.y === b.y &&
    a.width === b.width &&
    a.height === b.height;
}
